import type { PredictedSkills } from './predicted-skills.model';
import { defaultPredictedSkills } from '../skills/skills.seed';

export interface GeneratePredictedSkillsOptions {
  readonly title: string;
  readonly description: string;
  readonly skillIds?: readonly number[];
}

export function generatePredictedSkillsObject({
  title,
  description,
  skillIds = defaultPredictedSkills.map(skill => skill.id),
}: GeneratePredictedSkillsOptions): PredictedSkills {
  return {
    id: `${title}-${description}`,
    title,
    description,
    skills: skillIds,
  };
}
